<template>
    <b-row align-v="center">
        <b-col v-for="(video,index) in videoList"
               v-bind:video="video"
               v-bind:key="video.id"
               :class="colClass(index)">
            <video controls autoplay playsinline ref="videos"
                   :muted="video.muted"
                   :id="video.id"
                   class="mv-100"/>
        </b-col>
    </b-row>
</template>

<script>
import Vue from 'vue'
import {io} from "socket.io-client"
import SimpleSignalClient from 'simple-signal-client'
import router from "@/apps/default/router";

export default Vue.extend({
    name: 'vue-webrtc',
    components: {},
    data() {
        return {
            signalClient: null,
            videoList: [],
            canvas: null,
            socket: null,
        }
    },
    props: {
        roomId: {
            type: String,
            default: 'public-room-v2'
        },
        socketURL: {
            type: String,
            default: 'https://weston-vue-webrtc-lobby.azurewebsites.net'
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        audioSource: {
            type: String,
            default: null
        },
        audioOutput: {
            type: String,
            default: null
        },
        videoSource: {
            type: String,
            default: null
        },
        screenshotFormat: {
            type: String,
            default: 'image/jpeg'
        },
        enableAudio: {
            type: Boolean,
            default: true
        },
        enableVideo: {
            type: Boolean,
            default: true
        },
        enableLogs: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        },
        show: {
            type: Boolean,
            default: true,
        },
        peerOptions: {
            type: Object,  // NOTE: use these options: https://github.com/feross/simple-peer
            default() {
                return {}
            }
        },
        ioOptions: {
            type: Object,  // NOTE: use these options: https://socket.io/docs/v4/client-options/
            default() {
                return {rejectUnauthorized: false, transports: ['polling', 'websocket']}
            }
        },
    },
    watch: {
        muted() {
            this.videoList.forEach(video => {
                if (video.isLocal) {
                    video.stream.getAudioTracks().forEach(track => {
                        track.enabled = !this.muted
                    })
                }
            })
        },
        show() {
            this.videoList.forEach(video => {
                if (video.isLocal) {
                    video.stream.getVideoTracks().forEach(track => {
                        console.log('VueWebRTC:show  this.show=' + this.show)
                        track.enabled = this.show
                    })
                }
            })
        },
        audioOutput() {
            if (this.audioOutput && this.$refs.videos && this.$refs.videos.length) {
                this.$refs.videos.forEach(video => {
                    if (video.setSinkId)
                        video.setSinkId(this.audioOutput)
                            .then(() => {
                                console.log('VueWebRTC:audioOutput  setSinkId success')
                            })
                            .catch(error => {
                                console.log('VueWebRTC:audioOutput  error=', error)
                            })
                })
            }
        },
        audioSource() {
            console.log('VueWebRTC:audioSource  this.audioSource=', this.audioSource)
            if (this.audioSource && this.socket)
                this.rejoin()
        },
        videoSource() {
            console.log('VueWebRTC:videoSource  this.videoSource=', this.videoSource)
            if (this.videoSource && this.socket)
                this.rejoin()
        }
    },
    mounted() {
        console.log('VueWebRTC:mounted')
    },
    methods: {
        colClass(index) {
            let classes = ['text-center', 'p0', 'm0', 'embed-responsive', 'embed-responsive-4by3']
            switch (this.videoList.length) {
                case 0:
                case 1:
                    break
                case 2:
                case 3:
                case 4:
                    classes.push('col-12', 'col-sm-12', 'col-md-6', 'col-lg-6', 'col-xl-6')
                    break
                case 5:
                case 6:
                    classes.push('col-12', 'col-sm-12', 'col-md-4', 'col-lg-4', 'col-xl-4')
                    break
                default:
                    classes.push('col-12', 'col-sm-6', 'col-md-4', 'col-lg-3', 'col-xl-3')
                    break
            }
            return classes.join(' ')
        },
        async join() {
            console.log('VueWebRTC:join')
            const that = this
            this.socket = io(this.socketURL, this.ioOptions)
            this.signalClient = new SimpleSignalClient(this.socket)
            let constraints = {
                video: this.enableVideo,
                audio: this.enableAudio
            }
            if (this.videoSource && this.enableVideo) {
                constraints.video = {deviceId: {exact: this.videoSource}}
            }
            if (navigator.mediaDevices) {
                const localStream = await navigator.mediaDevices.getUserMedia(constraints)
                console.log('VueWebRTC:join  localStream=', localStream)
                this.joinedRoom(localStream, true)
                this.signalClient.once('discover', discoveryData => {
                    console.log('VueWebRTC:join  discoveryData=', discoveryData)

                    async function connectToPeer(peerID) {
                        if (peerID === that.socket.id)
                            return
                        try {
                            console.log('VueWebRTC:join  connecting to peer')
                            const {peer} = await that.signalClient.connect(peerID, that.roomId, that.peerOptions)
                            that.videoList.forEach(video => {
                                if (video.isLocal)
                                    that.onPeer(peer, video.stream)
                            })
                        } catch (error) {
                            console.log('VueWebRTC:join  peer connecting  error=', error)
                        }
                    }

                    discoveryData.peers.forEach(peerID => connectToPeer(peerID))
                    that.$emit('opened-room', that.roomId)
                })
            } else
                router.app.$toasted.error('Unable to access media devices', {duration: 5000})
            this.signalClient.on('request', async request => {
                const {peer} = await request.accept({}, that.peerOptions)
                console.log('VueWebRTC:join:signalClient:request  request=', request, '  peer=', peer)
                that.videoList.forEach(video => {
                    if (video.isLocal)
                        that.onPeer(peer, video.stream)
                })
            })
            this.signalClient.discover(this.roomId)
        },
        onPeer(peer, localStream) {
            console.log('VueWebRTC:onPeer')
            peer.addStream(localStream)
            peer.on('stream', remoteStream => {
                this.joinedRoom(remoteStream, false)
                peer.on('close', () => {
                    this.removeFromVideoList(remoteStream.id)
                    this.$emit('left-room', remoteStream.id)
                })
                peer.on('error', error => {
                    console.log('VueWebRTC:onPeer  error=', error)
                })
            })
        },
        joinedRoom(stream, isLocal) {
            let found = this.videoList.find(video => {
                return video.id === stream.id
            })
            if (found === undefined) {
                let video = {
                    id: stream.id,
                    muted: isLocal,
                    stream: stream,
                    isLocal: isLocal
                }
                this.videoList.push(video)
            }
            // set stream to video object (delayed)
            setTimeout(() => {
                if (this.$refs.videos)
                    this.$refs.videos.forEach(video => {
                        if (video.id === stream.id)
                            video.srcObject = stream
                    })
            }, 500)
            this.$emit('joined-room', stream.id)
        },
        leave() {
            if (this.videoList) {
                this.videoList.forEach(v => v.stream.getTracks().forEach(t => t.stop()))
                this.videoList = []
            }
            if (this.signalClient) {
                this.signalClient.peers().forEach(peer => peer.removeAllListeners())
                this.signalClient.destroy()
                this.signalClient = null
            }
            if (this.socket) {
                this.socket.destroy()
                this.socket = null
            }
        },
        removeFromVideoList(id) {
            let newVideoList = []
            this.videoList.forEach(video => {
                if (video.id !== id)
                    newVideoList.push(video)
            })
            this.videoList = newVideoList
        },
        rejoin() {
            console.log('VueWebRTC:rejoin')
            this.leave()
            this.join()
        },
        async share() {
            if (navigator.mediaDevices !== undefined) {
                try {
                    let screenStream = await navigator.mediaDevices.getDisplayMedia({video: true, audio: false})
                    screenStream.oninactive = () => {
                        console.log('VueWebRTC:share  oninactive')
                        this.removeFromVideoList(screenStream.id)
                        this.$emit('share-stopped', screenStream)
                    }
                    this.joinedRoom(screenStream, true)
                    this.$emit('share-started', screenStream)
                    if (this.signalClient)
                        this.signalClient.peers().forEach(peer => this.onPeer(peer, screenStream))
                } catch (error) {
                    console.log('VueWebRTC:share  error=', error)
                }
            } else
                console.log('VueWebRTC:share  https is required to load cameras')
        },
        async unshare(share) {
            if (share && share.id) {
                console.log('VueWebRTC:unshare  share=', share)
                this.removeFromVideoList(share.id)
                if (share.getTracks) {
                    const tracks = share.getTracks();
                    if (tracks)
                        tracks.forEach(track => track.stop());
                }
                if (this.socket)
                    this.rejoin()
                this.$emit('share-stopped', share)
            }
        },
    }
})
</script>
<style lang="scss" scoped>
.video-list {
    video {
        min-height: 200px;
    }
}
</style>
